/**
 * Created by rhinov15 on 28/01/2016.
 *
 * UI State
 *
 */

import { math } from "@rhinov/savane-js";
import { UiState, UiStateEnum } from "./UiState";

export class RoomMagnetState extends UiState {

    _magnetPosition = math.vec3.create();
    _magnetX = false;
    _magnetY = false;

    constructor(cursorPosition: math.vec3, cocosPosition: math.vec3) {
        super(cursorPosition, cocosPosition);
        
    }

    // Return value from gloabl enum
    getUiState(): number {
        return UiStateEnum.uiRoomMagnetState;
    }

    // The mouse is moving in this state
    moveMouseCursor(cursorPosition: math.vec3, cocosPos: math.vec3): UiState | null {
        // Copy cursor position before calling next Ui State
        math.vec3.copy(this.cursorPosition, cursorPosition);
        // Ant cocos position too
        this.cocosPosition = cocosPos;

        // Do we stay in the current state ?
        if (this.getNextUiState() === this.getUiState()) {
            // Yes, copy cursor position
            this.cursorPosition = cursorPosition;
            // Get selection (will call parent)
            this.setSelected();
            return null;
        }
        else {
            // No we leave to next state
            return this.createNextUiState();
        }
    }
}
